<script>
    import { templates } from "vuelidate-error-extractor";

    export default {
        name: "FormWrapper",
        extends: templates.FormWrapper,
    }
</script>
